import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { QuebecModalComponent } from './quebec-modal.component';

import { ModalModule } from '../modal/modal.module';

import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        SharedPipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        QuebecModalComponent
    ],
    exports: [
        QuebecModalComponent
    ]
})
export class QuebecModalModule { }
